import { trackingEvent } from '@notino/web-tracking';

import { dispatchEcommerceMessage } from '@services/messagingService';

import { EcommerceSectionNamespace } from '../../model';

export const trackOnVoucherCopyClick = (timing: number, voucherCode: string) => {
  dispatchEcommerceMessage(
    trackingEvent({
      event: EcommerceSectionNamespace.EEcommerceEvent.ELEMENT_CLICK,
      element: {
        name: voucherCode,
        type: EcommerceSectionNamespace.EEcommerceType.CART,
        interaction: EcommerceSectionNamespace.EEcommerceInteraction.PICTOGRAM_COPY,
        timing,
        action: EcommerceSectionNamespace.EEcommerceAction.COPY_COUPON_CODE,
      },
      _clear: true,
    }),
  );
};
